var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarCardSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#E1E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2357 77.3002C52.8915 74.6686 58.2704 73.1667 64 73.1667C69.7296 73.1667 75.1085 74.6686 79.7643 77.3002M70.875 59.4167C70.875 63.2136 67.797 66.2917 64 66.2917C60.203 66.2917 57.125 63.2136 57.125 59.4167C57.125 55.6197 60.203 52.5417 64 52.5417C67.797 52.5417 70.875 55.6197 70.875 59.4167ZM84.625 64C84.625 75.3909 75.3909 84.625 64 84.625C52.6091 84.625 43.375 75.3909 43.375 64C43.375 52.6091 52.6091 43.375 64 43.375C75.3909 43.375 84.625 52.6091 84.625 64Z",
    stroke: "#75019C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarCardSvg);
export default __webpack_public_path__ + "static/media/AvatarCardSvg.91b6cf9e48f00c336c6af29f21d849fe.svg";
export { ForwardRef as ReactComponent };